// Regras das ações da grid da Conta Corrente do Processo (consultar origem, excluir e perda).

const ORIGEM_SOLICITACAO_PAGAMENTO = 'SOLICITACAO_PAGAMENTO';
const ORIGEM_NUMERARIO = 'NUMERARIO';
const ORIGEM_FATURAMENTO = 'FATURAMENTO';
const ORIGEM_MANUAL = 'MANUAL';
const ORIGEM_CONCILIACAO = 'CONCILIACAO';

const ORIGENS_REGISTRO_DI = [
  'REGISTRO DI',
  'REGISTRO DI IMPOSTOS',
  'Nova Fatura DI/DUIMP',
  'Alteração registro DI/DUIMP',
];

const PRODUTO_EXPORTACAO = 'EXPORTACAO';

const isOrigem = (row, origem) => row?.origemChave === origem;

const isOrigemRegistroDi = (row) => ORIGENS_REGISTRO_DI.includes(row?.origemChave);

// Lançamentos antigos de solicitação de pagamento gravam o tipo da solicitação
// (OPERACIONAL/ADMINISTRATIVA) no lugar da origem, por isso a solicitação é
// identificada pelo id resolvido no backend, e não pela origem.
const isDeSolicitacaoPagamento = (row) => !!row?.solicitacaoPagamentoId;

// Rota do lançamento original, no módulo que o gerou. Retorna undefined quando não há
// para onde navegar (origem sem tela própria ou id da origem ausente no lançamento).
const resolveRotaOrigem = (row, followUpId) => {
  if (isDeSolicitacaoPagamento(row)) {
    return `/financeiro/solicitacao-de-pagamento/${row.solicitacaoPagamentoId}/detalhes`;
  }

  if (isOrigem(row, ORIGEM_NUMERARIO) && row?.numerarioId) {
    return row?.produto === PRODUTO_EXPORTACAO
      ? `/exportacao/numerario/${row.numerarioId}/detalhes`
      : `/importacao/numerarios/${row.numerarioId}/detalhes`;
  }

  if (isOrigem(row, ORIGEM_FATURAMENTO) && row?.faturamentoId) {
    return `/financeiro/faturamento/${row.faturamentoId}/detalhes`;
  }

  if (isOrigem(row, ORIGEM_MANUAL) && row?.movimentacaoFinanceiroId && followUpId) {
    return `/financeiro/conta-corrente-processo/${followUpId}/${row.movimentacaoFinanceiroId}/detalhes`;
  }

  if (isOrigemRegistroDi(row) && row?.declaracaoImportacaoId) {
    return `/importacao/declaracoes-de-importacao/${row.declaracaoImportacaoId}/detalhes`;
  }

  if (isOrigem(row, ORIGEM_CONCILIACAO) && row?.tituloMovimentacaoId) {
    return `/financeiro/conciliacao-bancaria/${row.tituloMovimentacaoId}`;
  }

  return undefined;
};

// Só os lançamentos criados direto na conta corrente podem ser excluídos.
const isExclusaoHabilitada = (row) => isOrigem(row, ORIGEM_MANUAL) && !row?.cancelado;

// Origens que aceitam perda além da solicitação de pagamento. Nelas o lançamento não tem
// solicitação, então a perda fica registrada no próprio título.
const ORIGENS_COM_PERDA = [ORIGEM_NUMERARIO, ORIGEM_CONCILIACAO];

// A perda tira o lançamento do saldo do processo e o joga no total de perdas, então só vale
// enquanto ele não foi faturado. Sempre precisa de um título, que é onde a perda é gravada.
const isPerdaHabilitada = (row) =>
  (isDeSolicitacaoPagamento(row) || ORIGENS_COM_PERDA.includes(row?.origemChave)) &&
  !!row?.tituloId &&
  !row?.faturado &&
  !row?.cancelado;

// Observação do diálogo de perda: a solicitação de pagamento tem o caso da solicitação múltipla,
// em que a perda vale para a solicitação inteira e não só para a linha escolhida.
const getObservacaoPerda = (row, removendo) => {
  if (!isDeSolicitacaoPagamento(row)) {
    return 'A perda fica registrada no título que originou o lançamento.';
  }

  if (row?.solicitacaoMultipla && !removendo) {
    return 'A solicitação de pagamento tem várias despesas: a perda vale para o total da solicitação, não só para esta linha.';
  }

  return 'A perda fica registrada na solicitação de pagamento que originou o lançamento.';
};

const ContaCorrenteProcessoUtils = {
  ORIGEM_SOLICITACAO_PAGAMENTO,
  ORIGEM_NUMERARIO,
  ORIGEM_FATURAMENTO,
  ORIGEM_MANUAL,
  ORIGEM_CONCILIACAO,
  isOrigemRegistroDi,
  isDeSolicitacaoPagamento,
  resolveRotaOrigem,
  isExclusaoHabilitada,
  isPerdaHabilitada,
  getObservacaoPerda,
};

export default ContaCorrenteProcessoUtils;
